// extracted by mini-css-extract-plugin
module.exports = {"footerSocial":"_3YCdE","footerSocialTitle":"_3bpPi","footerSocialWrapper":"_3kz_C"};